import { render, staticRenderFns } from "./humanResources.vue?vue&type=template&id=6bbfd16a&scoped=true"
import script from "./humanResources.vue?vue&type=script&lang=js"
export * from "./humanResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbfd16a",
  null
  
)

export default component.exports